import { useState } from "react";
import { FaWhatsapp } from "react-icons/fa";
import SupportModal from "./SupportModal";

const SupportFloatingButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setIsOpen(true)}
        aria-label="Falar com o suporte"
        title="Falar com o suporte"
        className="fixed bottom-4 right-4 z-40 inline-flex items-center gap-2 bg-white text-slate-600 border border-slate-200 shadow-md rounded-full pl-2.5 pr-3 py-2 text-sm font-medium hover:text-slate-900 hover:border-slate-300 hover:shadow-lg focus:ring-2 focus:ring-slate-700/20 focus:outline-none transition-all duration-200"
      >
        <FaWhatsapp className="w-5 h-5 text-emerald-600" />
        <span className="hidden sm:inline">Suporte</span>
      </button>

      <SupportModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
};

export default SupportFloatingButton;
